import Modal from "components/modal/modal";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import clsx from 'clsx';
import { useState } from "react";
import FileUploader from "components/file-uploader/file-uploader";
import FileUploadItem from "components/file-upload-item/file-upload-item";
import { ParseUserInitials } from "@myinnsworth/helpers/userHelpers";
import { caseHttpService } from "@myinnsworth/httpServices";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Icon from "components/icon/icon";
import prettyBytes from "pretty-bytes";

interface IEmailManagerSchema {
    message: string;
}

const emailManagerSchema = yup.object({
    message: yup.string().required('You must enter a message'),
}).required();


export interface IEmailCaseManagerProps {
    show: boolean;
    caseManagerName: string;
    caseSlug?: string;
    onClose: () => void;
}

type ModalState = 'none' | 'select-files' | 'success';

export default function EmailCaseManagerModal(props: IEmailCaseManagerProps) {
    const [modalState, setModalState] = useState<ModalState>('none');

    const [files, setFiles] = useState<Array<File>>([]);

    const { register: registerInput, handleSubmit, clearErrors, formState: { errors } } = useForm<IEmailManagerSchema>({
        resolver: yupResolver(emailManagerSchema)
    });

    const removeFile = (file:File) => {
        setFiles(files.filter(x => x !== file));
    };

    const onClose = () => {
        clearErrors();
        props.onClose();
        setModalState('none');
    };

    const onSubmit = async (formData: IEmailManagerSchema) => {
        clearErrors();
        try {
            if(props.caseSlug) {
                await caseHttpService.emailCaseManager({
                    caseSlug: props.caseSlug,
                    ...formData
                }, files);
                setModalState('success');
            }
        } catch {

        }
    };

    const settings: any = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false
    };

    return (
        props.show ? (
            <Modal closeOnCoverClick={false} title={modalState === 'success' ? 'Your message has been successfully sent' : 'Email Case Manager'} onClose={onClose}>
                {modalState === 'success' && (<>
                    <p>Thank you for your message.  We aim to reply as soon as possible.  Please allow 2-3 working days</p>
                </>)}
                {modalState === 'select-files' && (<>
                    <div>
                        <FileUploader onUpload={(selectedFiles) => {
                            setFiles([
                                ...files,
                                ...selectedFiles
                            ]);
                        }} />

                        <div className="file-upload-items">
                            {files.map((file, idx) => <FileUploadItem
                                key={idx}
                                name={file.name}
                                size={file.size}
                                file={file}
                                onDelete={(file) => { removeFile(file); }}
                            />)}
                        </div>

                        <div className="flex justify-right">
                            <button className="btn primary medium" onClick={() => setModalState('none')}>Back</button>
                        </div>
                    </div>
                </>)}

                {modalState === 'none' && (<>
                    <div className="flex align-center justify-space-between">
                        <div className="user-profile">
                            <span>{ParseUserInitials({ displayName: props.caseManagerName })}</span>
                            {/* <img src="" alt=""> */}
                            <p>{props.caseManagerName}</p>
                        </div>

                        <a className="link primary" onClick={() => setModalState('select-files')}>
                            Add attachment
                            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 10.8002V8.7002C13 7.20903 11.7912 6.0002 10.3 6.0002H9.1C8.60294 6.0002 8.2 5.59725 8.2 5.1002V3.9002C8.2 2.40903 6.99117 1.2002 5.5 1.2002H4M7 8.4002V13.2002M9.4 10.8002H4.6M5.8 1.2002H1.9C1.40294 1.2002 1 1.60314 1 2.1002V15.9002C1 16.3973 1.40294 16.8002 1.9 16.8002H12.1C12.5971 16.8002 13 16.3973 13 15.9002V8.4002C13 4.42375 9.77645 1.2002 5.8 1.2002Z" stroke="#01065B" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </div>

                    {files.length > 0 && (
                        <div className="uploaded-files-container">

                        <Slider {...settings}>
                                {files.map((file, i) => 
                                    <div key={i} className="uploaded-file">
                                        <div className="content">
                                            <div className="details">
                                                <label title={file.name}>{file.name}</label>
                                                <p>{prettyBytes(file.size)}</p>
                                            </div>

                                            <button title="delete" onClick={() => removeFile(file)}>
                                                <Icon name="delete" width="14" height="18px" />
                                            </button>
                                        </div>
                                    </div>
                                )}
                        </Slider>
                    </div>
                    )}

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={clsx('form-control', 'normal', { 'error': errors.message })}>
                            <textarea {...registerInput('message')} placeholder="Enter your message ..."></textarea>
                            {errors.message && (<p>{errors.message.message}</p>)}
                        </div>

                        <div className="flex justify-right">
                            <button type="submit" className="btn primary medium">Send email</button>
                        </div>
                    </form>
                </>)}
            </Modal>
        ) : <></>
    );
}